import { useMutation } from '@apollo/client'
import { AddSubperson, AddSubpersonVariables } from '../../types'
import { ADD_SUBPERSON } from './operations'

export const useAddSubperson = () => useMutation<AddSubperson, AddSubpersonVariables>(ADD_SUBPERSON)
